/* globals navigator:false */

const userAgent = navigator.userAgent.toLowerCase()

export default {
  isIE: isIE(userAgent),
  isEdge: isEdge(userAgent)
}

function isIE (userAgent) {
  return userAgent.indexOf('msie') > 0 || userAgent.indexOf('trident/') > 0
}

function isEdge (userAgent) {
  return userAgent.indexOf('edge') > 0
}
